import React, { useState, useEffect, useContext, useRef } from 'react';
// import AxiosInstance from '../utils/AxiosInstance';
import FilterContext from '../utils/FilterContext';
import LoadingSpinner from './LoadingSpinner';
import '../Css/CenterReport.css';
import { ModalHeader } from 'react-bootstrap';
import { th, tr } from 'date-fns/locale';

import { useConfig } from "../utils/ConfigContext.jsx";
import {createAxiosInstance} from "../utils/AxiosInstance.jsx";

const CenterReportMain = () => {
    const { API_BASE_URL } = useConfig(); // ✅ from context
    const AxiosInstance = createAxiosInstance(API_BASE_URL);

    const [loadingStates, setLoadingStates] = useState({
        leads: false,
        opd: false,
        package: false,
        conversion: false
    });
    const [error, setError] = useState(null);
    const [leadData, setLeadData] = useState({
        details: [],
        total: { total: 0, converted: 0 }
    });
    const [patientTransferData, setPatientTransferData] = useState({
        transfer_from_here: 0,
        transfer_to_here: 0
    });
    const [opdData, setOpdData] = useState([]);
    const [opdTotal, setOpdTotal] = useState({
        scheduled_opd: 0,
        opd: 0,
        unique_opd_patients: 0,
        new_opd: 0,
        old_opd: 0,
        recommendation_snb: 0,
        recommendation_sdt: 0,
        recommended_sdt_snb: 0,
        convert_to_snb: 0,
        convert_to_sdt: 0,
        convert_to_snb_sdt: 0,
        recommended_ct_angio: 0,
        recommended_medical_management: 0,
        not_viable: 0
    });
    const [packageData, setPackageData] = useState([]);
    const [treatmentData, setTreatmentData] = useState({
        no_of_machine: { snb: 0, sdt: 0 },
        no_of_treatments: { snb: 0, sdt: 0 },
        no_of_potential_treatment: { snb: 0, sdt: 0 },
        CUI: { snb: 0, sdt: 0 }
    });
    const [conversionRows, setConversionRows] = useState([]);
    const [conversionTotals, setConversionTotals] = useState({ snb: 0, sdt: 0, snb_sdt: 0, total: 0 });

    // Access filter data and setter function from context
    const { filters, setFilters } = useContext(FilterContext);
    const filtersRef = useRef(filters);
    const getPreviousMonthDates = () => {
        const today = new Date();
        // Get the first day of previous month
        const firstDay = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        // Get the last day of previous month
        const lastDay = new Date(today.getFullYear(), today.getMonth(), 0);

        // Format dates as YYYY-MM-DD
        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        return {
            start: formatDate(firstDay),
            end: formatDate(lastDay)
        };
    };

    const defaultDates = getPreviousMonthDates();
    const [apiPayload, setApiPayload] = useState({
        'startDate': defaultDates.start,
        'endDate': defaultDates.end,
        'center_id': 1,
    });

    const [hospitalName, setHospitalName] = useState(''); // Default to empty string if not available
    const [dateRange, setDateRange] = useState(''); // Default to empty string if not available


    // Handle initial load and filter changes
    useEffect(() => {
        if (!filters) return; // Guard against null filters

        if (!filtersRef.current || filtersRef.current !== filters) {
            filtersRef.current = filters;

            // If we have filter data, use it; otherwise use default values
            let newPayload = apiPayload;

            if (filters.dateRange && filters.centerName) {
                const [startDate, endDate] = filters.dateRange.split(" - ").map(date => date.trim());
                const [startDate1, endDate1] = filters.dateRange.split(" - ").map(date => date.split("-").reverse().join("-"));

                newPayload = {
                    'startDate': startDate,
                    'endDate': endDate,
                    'center_id': filters.centerName.id,
                };

                setApiPayload(newPayload);
                setHospitalName(filters.centerName.label || '');
                setDateRange(startDate1 + " - " + endDate1);
            }

            // Fetch both lead and OPD data
            getLeadData(newPayload);
            fetchOpdDetails(newPayload);
            fetchPackageAndTreatmentDetails(newPayload);
            fetchTreatmentConversionDetails(newPayload);

        }
    }, [filters]);
    // Helper function to create a CSV from an array of objects.
    // `headers` can be either an array of strings (legacy) or an array of
    // objects like { label: 'Source', key: 'source' } to allow a display
    // header that differs from the object key used to pull values.
    const convertToCsv = (data, headers) => {
        // Build label row
        const headerLabels = headers.map(h => (typeof h === 'string' ? h : h.label));
        const headerRow = headerLabels.join(',') + '\n';

        const csvRows = data.map(row =>
            headers.map((h, idx) => {
                const key = typeof h === 'string' ? h : h.key;
                const value = row[key] !== undefined ? row[key] : '';
                return `"${value}"`;
            }).join(',')
        );

        return headerRow + csvRows.join('\n');
    };

    // Helper function to handle the export to excel functionality.
    const handleExportToExcel = () => {
        // Data for the "Lead Details" table using dynamic data
        const leadDetails = leadData.details;
        // ensure the total object keys match the lowercase keys used in lead detail rows
        const leadTotal = { source: 'Total', total: leadData.total.total, converted: leadData.total.converted };
        // Use display labels while mapping to lowercase keys so the CSV shows Title Case headers
        const leadHeaders = [
            { label: 'Source', key: 'source' },
            { label: 'Total', key: 'total' },
            { label: 'Converted', key: 'converted' }
        ];
        const leadCsv = convertToCsv([...leadDetails, leadTotal], leadHeaders);

        // Data for the "Patients Details" section — use actual patientTransferData
        const patientsDetails = [
            { Details: 'Transferred To other Center', Count: patientTransferData.transfer_from_here || 0 },
            { Details: 'Transferred From other Center', Count: patientTransferData.transfer_to_here || 0 },
        ];
        const patientsHeaders = ['Details', 'Count'];
        const patientsCsv = convertToCsv(patientsDetails, patientsHeaders);

        // Data for the "OPD Details" table
        // Use an explicit mapping between display labels and object keys to avoid
        // brittle string transforms (space/case/symbol differences).
        const opdMetricMap = [
            { label: 'Pending OPD', key: 'scheduled_opd' },
            { label: 'Completed OPD', key: 'opd' },
            { label: 'Unique OPD Patients', key: 'unique_opd_patients' },
            { label: 'New OPD Patients', key: 'new_opd' },
            { label: 'Followup OPD Patients', key: 'old_opd' },
            { label: 'Recommendation SNB', key: 'recommendation_snb' },
            { label: 'Convert to SNB', key: 'convert_to_snb' },
            { label: 'Recommended SDT', key: 'recommendation_sdt' },
            { label: 'Convert To SDT', key: 'convert_to_sdt' },
            { label: 'Recommended SDT+SNB', key: 'recommended_sdt_snb' },
            { label: 'Convert to SNB+SDT', key: 'convert_to_snb_sdt' },
            { label: 'Recommended CT-angio', key: 'recommended_ct_angio' },
            { label: 'Recommended to Medical Management', key: 'recommended_medical_management' },
            { label: 'Not Viable', key: 'not_viable' }
        ];

        const opdDetails = opdMetricMap.map(metric => {
            const row = { Details: metric.label };
            opdData.forEach(doctor => {
                row[doctor.doctor_name] = doctor[metric.key] || 0;
            });
            row.Total = opdTotal[metric.key] || 0;
            return row;
        });
        const opdHeaders = ['Details', ...opdData.map(d => d.doctor_name), 'Total'];
        const opdCsv = convertToCsv(opdDetails, opdHeaders);

        // Data for the "Package Details" table — derive values from packageData
        const packageDetails = [];
        // first day running
        packageDetails.push({
            Details: 'Day 1 Running',
            SNB: packageData?.opening_package?.snb || 0,
            SDT: packageData?.opening_package?.sdt || 0,
            SDT_SNB: packageData?.opening_package?.snb_sdt || 0,
            Total: (packageData?.opening_package?.snb || 0) + (packageData?.opening_package?.sdt || 0)
        });

        // new booking
        packageDetails.push({
            Details: 'This Date Range Patient Booking',
            SNB: packageData?.added_package?.snb || 0,
            SDT: packageData?.added_package?.sdt || 0,
            SDT_SNB: packageData?.added_package?.snb_sdt || 0,
            Total: (packageData?.added_package?.snb || 0) + (packageData?.added_package?.sdt || 0)
        });

       

        // total running
        packageDetails.push({
            Details: 'Total Running Package',
            SNB: packageData?.total_run_package?.snb || 0,
            SDT: packageData?.total_run_package?.sdt || 0,
            SDT_SNB: packageData?.total_run_package?.snb_sdt || 0,
            Total: (packageData?.total_run_package?.snb || 0) + (packageData?.total_run_package?.sdt || 0)
        });

        // scheduled to complete packages
        packageDetails.push({
            Details: 'Scheduled to Complete Packages',
            SNB: packageData?.scheduled_to_complete_packages?.snb || 0,
            SDT: packageData?.scheduled_to_complete_packages?.sdt || 0,
            SDT_SNB: packageData?.scheduled_to_complete_packages?.snb_sdt || 0,
            Total: (packageData?.scheduled_to_complete_packages?.snb || 0) + (packageData?.scheduled_to_complete_packages?.sdt || 0)
        });

        // this date range completed
        packageDetails.push({
            Details: 'This Date Range Completed',
            SDT: packageData?.completed_packages?.sdt || 0,
            SNB: packageData?.completed_packages?.snb || 0,
            SDT_SNB: packageData?.completed_packages?.snb_sdt || 0,
            Total: (packageData?.completed_packages?.snb || 0) + (packageData?.completed_packages?.sdt || 0)
        });

        //pending to complete packages
        packageDetails.push({
            Details: 'Pending to Complete Packages',
            SNB: packageData?.pending_to_complete_packages?.snb || 0,
            SDT: packageData?.pending_to_complete_packages?.sdt || 0,
            SDT_SNB: packageData?.pending_to_complete_packages?.snb_sdt || 0,
            Total: (packageData?.pending_to_complete_packages?.snb || 0) + (packageData?.pending_to_complete_packages?.sdt || 0)
        });

        //last day run (closing)
        packageDetails.push({
            Details: 'Last Day Running',
            SNB: packageData?.closing_package?.snb || 0,
            SDT: packageData?.closing_package?.sdt || 0,
            SDT_SNB: packageData?.closing_package?.snb_sdt || 0,
            Total: (packageData?.closing_package?.snb || 0) + (packageData?.closing_package?.sdt || 0)
        });

        const packageHeaders = ['Details', 'SNB', 'SDT', 'SDT_SNB', 'Total'];
        const packageCsv = convertToCsv(packageDetails, packageHeaders);

        // Data for the "Conversion Details" table — derive values from conversionRows
        const conversionDetails = (conversionRows || []).map(r => ({
            label: r.label,
            snb: r.snb || 0,
            sdt: r.sdt || 0,
            snb_sdt: r.snb_sdt || 0,
            total: r.total || 0
        }));
        const conversionTotal = { label: 'Total', snb: conversionTotals?.snb || 0, sdt: conversionTotals?.sdt || 0, snb_sdt: conversionTotals?.snb_sdt || 0, total: conversionTotals?.total || 0 };
        const conversionHeaders = [
            { label: 'Details', key: 'label' },
            { label: 'SNB', key: 'snb' },
            { label: 'SDT', key: 'sdt' },
            { label: 'SNB+SDT', key: 'snb_sdt' },
            { label: 'Total', key: 'total' }
        ];
        const conversionCsv = convertToCsv([...conversionDetails, conversionTotal], conversionHeaders);

        // Data for the "Treatment Details" table — derive values from treatmentData
        const treatmentDetails = [
            {
                Total: 'No. of Machines',
                SNB: treatmentData?.no_of_machine?.snb || 0,
                SDT: treatmentData?.no_of_machine?.sdt || 0
            },
            {
                Total: 'No. of Sittings (Treatments)',
                SNB: treatmentData?.no_of_treatments?.snb || 0,
                SDT: treatmentData?.no_of_treatments?.sdt || 0
            },
            {
                Total: 'No. of Potential Sittings (Treatments)',
                SNB: treatmentData?.no_of_potential_treatment?.snb || 0,
                SDT: treatmentData?.no_of_potential_treatment?.sdt || 0
            },
            {
                Total: 'CUI (%)',
                SNB: treatmentData?.CUI?.snb || 0,
                SDT: treatmentData?.CUI?.sdt || 0
            }
        ];

        const treatmentHeaders = ['Total', 'SNB', 'SDT'];
        const treatmentCsv = convertToCsv(treatmentDetails, treatmentHeaders);

        // Combine all CSV strings with section headers
        const headerInfo = `Center: ${hospitalName || 'All'} , Date Range: ${dateRange || (defaultDates.start + ' - ' + defaultDates.end)}\n\n`;
        const combinedCsv = headerInfo +
            `Lead Details\n${leadCsv}\n\nPatients Details\n${patientsCsv}\n\nOPD Details\n${opdCsv}\n\nPackage Details\n${packageCsv}\n\nConversion Details\n${conversionCsv}\n\nTreatment Details\n${treatmentCsv}\n`;

        const blob = new Blob([combinedCsv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Center_Report.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    //print
    const handlePrint = () => {
        const printContents = document.querySelector(".new_div").innerHTML;
        const printWindow = window.open("", "", "height=800,width=1000");

        printWindow.document.write(`
            <html>
                <head>
                    <title>Center Report</title>
                    <style>
                        @page { size: A4; margin: 20mm; }
                        body { -webkit-print-color-adjust: exact; font-family: sans-serif; }
                        table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
                        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                        th { background-color: #f2f2f2; }
                    </style>
                </head>
                <body>
                    ${printContents}
                </body>
            </html>
        `);

        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };

    // Fetch OPD details from API
    const fetchOpdDetails = async (apiPayload) => {
        setLoadingStates(prev => ({ ...prev, opd: true }));
        try {
             
            const response = await AxiosInstance.post("/center_report/opd", {
                startdate: apiPayload?.startDate ?? defaultDates.start,
                enddate: apiPayload?.endDate ?? defaultDates.end,
                center_id: apiPayload?.center_id ?? 1
            });

            if (response.data?.status && response.data?.data) {
                const opdDetails = Object.entries(response.data.data).map(([id, details]) => ({
                    id,
                    doctor_name: details.doctor_name,
                    ...details
                }));

                // if opdDetails has id = 24 then move it to the first position
                const index = opdDetails.findIndex(item => item.id === '24');
                if (index !== -1) {
                    const [item] = opdDetails.splice(index, 1);
                    opdDetails.unshift(item);
                }

                // Calculate totals
                const totals = opdDetails.reduce((acc, curr) => ({
                    scheduled_opd: (acc.scheduled_opd || 0) + (curr.scheduled_opd || 0),
                    opd: (acc.opd || 0) + (curr.opd || 0),
                    new_opd: (acc.new_opd || 0) + (curr.new_opd || 0),
                    old_opd: (acc.old_opd || 0) + (curr.old_opd || 0),
                    unique_opd_patients: (acc.unique_opd_patients || 0) + (curr.unique_opd_patients || 0),
                    recommendation_snb: (acc.recommendation_snb || 0) + (curr.recommendation_snb || 0),
                    recommendation_sdt: (acc.recommendation_sdt || 0) + (curr.recommendation_sdt || 0),
                    recommended_sdt_snb: (acc.recommended_sdt_snb || 0) + (curr.recommended_sdt_snb || 0),
                    convert_to_snb: (acc.convert_to_snb || 0) + (curr.convert_to_snb || 0),
                    convert_to_sdt: (acc.convert_to_sdt || 0) + (curr.convert_to_sdt || 0),
                    convert_to_snb_sdt: (acc.convert_to_snb_sdt || 0) + (curr.convert_to_snb_sdt || 0),
                    recommended_ct_angio: (acc.recommended_ct_angio || 0) + (curr.recommended_ct_angio || 0),
                    recommended_medical_management: (acc.recommended_medical_management || 0) + (curr.recommended_medical_management || 0),
                    not_viable: (acc.not_viable || 0) + (curr.not_viable || 0)
                }), {});

                setOpdData(opdDetails);
                setOpdTotal(totals);

            }
        } catch (error) {
            console.error('Error fetching OPD details:', error);
            setError('Failed to fetch OPD details. Please try again.');
        } finally {
            setLoadingStates(prev => ({ ...prev, opd: false }));
        }
    };

    //fetch Package and treatment details from api
    const fetchPackageAndTreatmentDetails = async (apiPayload) => {
        setLoadingStates(prev => ({ ...prev, package: true }));
        try {
             
            const response = await AxiosInstance.post("/center_report/package_treatment", {
                startdate: apiPayload?.startDate ?? defaultDates.start,
                enddate: apiPayload?.endDate ?? defaultDates.end,
                center_id: apiPayload?.center_id ?? 1
            });

            if (response.data?.status && response.data?.data) {
                const { package_details, treatment_details } = response.data.data;

                if (package_details) {

                    setPackageData(package_details);
                }
                if (treatment_details) {

                    setTreatmentData(treatment_details);
                }

            }
        } catch (error) {
            console.error('Error fetching package and treatment details:', error);
            setError('Failed to fetch package and treatment details. Please try again.');
        } finally {
            setLoadingStates(prev => ({ ...prev, package: false }));
        }
    };

    // Fetch Treatment Conversion Details from API and process
    const fetchTreatmentConversionDetails = async (apiPayload) => {
        setLoadingStates(prev => ({ ...prev, conversion: true }));
        try {
             
            const response = await AxiosInstance.post('/center_report/treatment_conversion', {
                startdate: apiPayload?.startDate ?? defaultDates.start,
                enddate: apiPayload?.endDate ?? defaultDates.end,
                center_id: apiPayload?.center_id ?? 1
            });

            if (response.data?.status && response.data?.data) {
                processTreatmentConversion(response.data.data);
                setConversionTableData(response.data.data);
            }
        } catch (e) {
            console.error('Error fetching treatment conversion details:', e);
            // Do not set a global error to avoid masking other sections
        } finally {
            setLoadingStates(prev => ({ ...prev, conversion: false }));
        }
    };

    // Helper to process conversion JSON into table rows
    const processTreatmentConversion = (data) => {
        if (!data || typeof data !== 'object') {
            setConversionRows([]);
            setConversionTotals({ snb: 0, sdt: 0, snb_sdt: 0, total: 0 });
            return;
        }

        const rows = [];
        let grandSNB = 0;
        let grandSDT = 0;
        let grandBoth = 0;

        const computeCountsForPatients = (patients) => {
            let snbOnly = 0;
            let sdtOnly = 0;
            let both = 0;

            (patients || []).forEach((p) => {
                const bookings = Array.isArray(p.bookings) ? p.bookings : [];
                const hasSNB = bookings.some(b => Number(b.package_type) === 2);
                const hasSDT = bookings.some(b => Number(b.package_type) === 1);
                if (hasSNB && hasSDT) both += 1;
                else if (hasSNB) snbOnly += 1;
                else if (hasSDT) sdtOnly += 1;
            });

            return { snb: snbOnly, sdt: sdtOnly, snb_sdt: both, total: snbOnly + sdtOnly + both };
        };

        Object.entries(data).forEach(([key, value]) => {
            if (key === 'other_without_appointment') {
                const counts = computeCountsForPatients(value?.patients);
                rows.push({ label: 'Other (Without Appointment)', label_id: -1, ...counts });
                grandSNB += counts.snb; grandSDT += counts.sdt; grandBoth += counts.snb_sdt;
            } else if (key === 'other_without_recommendation') {
                const counts = computeCountsForPatients(value?.patients);
                rows.push({ label: 'Other (Without Recommendations)', label_id: -2, ...counts });
                grandSNB += counts.snb; grandSDT += counts.sdt; grandBoth += counts.snb_sdt;
            } else {
                // doctor groups keyed by id strings
                const doctorName = value?.doctor_name || 'Doctor';
                const counts = computeCountsForPatients(value?.patients);
                rows.push({ label: `Dr. ${doctorName}`, label_id: value?.doctor_id, ...counts });
                grandSNB += counts.snb; grandSDT += counts.sdt; grandBoth += counts.snb_sdt;
            }
        });

        // Keep doctors at top, then others; also stable order: id 24 first if exists, then others
        const doctorRows = rows.filter(r => r.label.startsWith('Dr. '));
        const otherRows = rows.filter(r => !r.label.startsWith('Dr. '));
        doctorRows.sort((a, b) => {
            // Prefer Dr. Bimal (24) first if present based on name; fallback alphabetical
            if (a.label.includes('Bimal') && !b.label.includes('Bimal')) return -1;
            if (!a.label.includes('Bimal') && b.label.includes('Bimal')) return 1;
            return a.label.localeCompare(b.label);
        });

        const orderedRows = [...doctorRows, ...otherRows];

        setConversionRows(orderedRows);
        setConversionTotals({ snb: grandSNB, sdt: grandSDT, snb_sdt: grandBoth, total: grandSNB + grandSDT + grandBoth });
    };

    //fetching data from api
    const getLeadData = async (apiPayload) => {
        setLoadingStates(prev => ({ ...prev, leads: true }));
        setError(null);
        try {
             
            const response = await AxiosInstance.post("/center_report/leads_patients", {
                startdate: apiPayload?.startDate ?? defaultDates.start,
                enddate: apiPayload?.endDate ?? defaultDates.end,
                center_id: apiPayload?.center_id ?? 1
            });

            if (response.data?.status && response.data?.data) {
                const { lead_details, patient_details } = response.data.data;

                if (lead_details) {
                    // Transform API data to match our state structure
                    const details = lead_details.map(lead => ({
                        source: lead.source_name,
                        source_id: lead.source_id,
                        total: parseInt(lead.total_leads) || 0,
                        converted: parseInt(lead.converted) || 0
                    }));

                    // Calculate totals
                    const total = details.reduce((acc, curr) => ({
                        total: acc.total + curr.total,
                        converted: acc.converted + curr.converted
                    }), { total: 0, converted: 0 });

                    setLeadData({ details, total });
                }

                if (patient_details) {
                    setPatientTransferData({
                        transfer_from_here: patient_details.transfer_from_here || 0,
                        transfer_to_here: patient_details.transfer_to_here || 0
                    });
                }
            }
        } catch (error) {
            console.error('Error fetching lead data:', error);
            setError('Failed to fetch Lead report data. Please try again.');
        } finally {
            setLoadingStates(prev => ({ ...prev, leads: false }));
        }
    }

    const [showModal, setShowModal] = useState(false);
    const [showPackageModal, setShowPackageModal] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [modalTitle, setModalTitle] = useState("");
    const [isModalLoading, setIsModalLoading] = useState(false);

    const [selectedTable, setSelectedTable] = useState('');
    const [tableHeader, setTableHeader] = useState([]);
    const [selectedColumn, setSelectedColumn] = useState('');
    const [selectedRow, setSelectedRow] = useState('');
    const [tableData, setTableData] = useState([]);
    const [conversionTableData, setConversionTableData] = useState([]);


    const tableConfig = {
        lead: {
            converted: {
                headers: ['#', 'Name', 'Phone Number', 'Patient ID', 'First Appointment Date'],
                fields: ['lm_name', 'lm_mobile', 'patient_unique_id', 'pam_app_date'],
            },
            total: {
                headers: ['#', 'Name', 'Phone Number'],
                fields: ['lm_name', 'lm_mobile'],
            },

        },
        patient: {
            to_other_center: {
                headers: ['#', 'Name', 'Patient ID', 'Transferrrd To'],
                fields: ['pm_name', 'patient_unique_id', 'ending_hospital_name'],
            },
            from_other_center: {
                headers: ['#', 'Name', 'Patient ID', 'Transferrrd from'],
                fields: ['pm_name', 'patient_unique_id', 'base_hospital_name'],
            }
        },
        opd: {
            pending_opd: {
                headers: ['#', 'Name', 'Patient ID', 'Appointment Date'],
                fields: ['pm_name', 'patient_unique_id', 'pam_app_date'],
            },
            completed_opd: {
                headers: ['#', 'Name', 'Patient ID', 'Appointment Date'],
                fields: ['pm_name', 'patient_unique_id', 'pam_app_date'],
            },
            unique_opd_patient: {
                headers: ['#', 'Name', 'Patient ID', 'Appointment Date'],
                fields: ['pm_name', 'patient_unique_id', 'pam_app_date'],
            },
            new_opd_patient: {
                headers: ['#', 'Name', 'Patient ID', 'Appointment Date'],
                fields: ['pm_name', 'patient_unique_id', 'pam_app_date'],
            },
            old_opd_patient: {
                headers: ['#', 'Name', 'Patient ID', 'Appointment Date'],
                fields: ['pm_name', 'patient_unique_id', 'pam_app_date'],
            },
            recommended_snb: {
                headers: ['#', 'Name', 'Patient ID', 'Appointment Date'],
                fields: ['pm_name', 'patient_unique_id', 'pam_app_date'],
            },
            recommended_sdt: {
                headers: ['#', 'Name', 'Patient ID', 'Appointment Date'],
                fields: ['pm_name', 'patient_unique_id', 'pam_app_date'],
            },
            recommended_snb_sdt: {
                headers: ['#', 'Name', 'Patient ID', 'Appointment Date'],
                fields: ['pm_name', 'patient_unique_id', 'pam_app_date'],
            },
            recommended_ct_angio: {
                headers: ['#', 'Name', 'Patient ID', 'Appointment Date'],
                fields: ['pm_name', 'patient_unique_id', 'pam_app_date'],
            },
            recommended_medical_management: {
                headers: ['#', 'Name', 'Patient ID', 'Appointment Date'],
                fields: ['pm_name', 'patient_unique_id', 'pam_app_date'],
            },
            not_viable: {
                headers: ['#', 'Name', 'Patient ID', 'Appointment Date'],
                fields: ['pm_name', 'patient_unique_id', 'pam_app_date'],
            },
            convert_to_snb: {
                headers: ['#', 'Name', 'Patient ID'],
                fields: ['pm_name', 'patient_unique_id'],
            },
            convert_to_sdt: {
                headers: ['#', 'Name', 'Patient ID'],
                fields: ['pm_name', 'patient_unique_id'],
            },
            convert_to_snb_sdt: {
                headers: ['#', 'Name', 'Patient ID'],
                fields: ['pm_name', 'patient_unique_id'],
            },

        },
        conversion: {
            snb: {
                headers: ['#', 'Patient_name', 'Patient ID', 'Mobile No.', 'Pakage Details'],
                fields: ['patient_name', 'patient_id', 'mobile_no', 'package_details']
            },
            sdt: {
                headers: ['#', 'Patient_name', 'Patient ID', 'Mobile No.', 'Pakage Details'],
                fields: ['patient_name', 'patient_id', 'mobile_no', 'package_details']
            },
            snb_sdt: {
                headers: ['#', 'Patient_name', 'Patient ID', 'Mobile No.', 'Pakage Details'],
                fields: ['patient_name', 'patient_id', 'mobile_no', 'package_details']
            },

        }

        // add more types as needed...
    };

    const fetchDetails = async (apiPayload, table, column, row = null) => {
        setShowModal(true);
        setIsModalLoading(true);
        if (table == 'lead') {
            setModalTitle(`Leads Details`);
        } else if (table == 'patient') {
            setModalTitle(`Patients Details`);
        } else if (table == 'opd') {
            setModalTitle(`Opd Details`);
        }
        else {
            setModalTitle(`${table} Details`);
        }



        // Set headers dynamically based on category and type
        const config = tableConfig[table]?.[column] || tableConfig[table]?.[row];
        if (!config) {
            console.error(`No table config found for ${table} → ${column} → ${row}`);
            setIsModalLoading(false);
            return;
        }
        setSelectedTable(table);
        setSelectedColumn(column);
        setSelectedRow(row);
        setTableHeader(config.headers);


        try {
           
            const response = await AxiosInstance.post(`/center_report/get_details`, {
                startdate: apiPayload?.startDate ?? defaultDates.start,
                enddate: apiPayload?.endDate ?? defaultDates.end,
                center_id: apiPayload?.center_id ?? 1,
                table,
                column,
                row
            });

            const data = response.data.data || [];
            setTableData(data);

        } catch (error) {
            console.error(`Error fetching ${table} details:`, error);
        } finally {
            setIsModalLoading(false);
        }
    };

    const fetchPackageDetails = async (apiPayload, table, column, row = null) => {
        setShowPackageModal(true);
        setIsModalLoading(true);
        setModalTitle(`Package Details`);
        setSelectedTable(table);
        setSelectedColumn(column);
        setSelectedRow(row);
        // setTableHeader(['#', 'Patient Name', 'Patient ID', 'Package Name', 'Booking Date', 'Completion Date', 'Status']);
        try {
            
            const response = await AxiosInstance.post(`/center_report/get_details`, {
                startdate: apiPayload?.startDate ?? defaultDates.start,
                enddate: apiPayload?.endDate ?? defaultDates.end,
                center_id: apiPayload?.center_id ?? 1,
                table,
                column,
                row
            });

            const data = response.data.data || [];
            setTableData(data);

        } catch (error) {
            console.error(`Error fetching ${table} package details:`, error);
        } finally {
            setIsModalLoading(false);
        }
    };

    const showConversionModal = (row, column) => {
        setShowModal(true);
        setIsModalLoading(true);
        setModalTitle('Treatment Conversion Details');
        setTableHeader(['#', 'Patient Name', 'Patient ID', 'Mobile No.', 'Package Details']);
        setSelectedTable('conversion');
        setSelectedColumn(column);
        setSelectedRow(row);

        // Identify which group to filter
        let group = null;

        if (row === -1) {
            // other_without_appointment
            // group = Object.values(conversionTableData).find(g => g.key === 'other_without_appointment');
            group = conversionTableData['other_without_appointment'];
        } else if (row === -2) {
            // other_without_recommendation
            group = conversionTableData['other_without_recommendation'];
        } else {
            // doctor id case
            group = Object.values(conversionTableData).find(g => Number(g.doctor_id) === Number(row));
        }

        const modalConversionRows = [];
        const patients = group?.patients || [];
        patients.forEach((patient) => {
            const bookings = Array.isArray(patient.bookings) ? patient.bookings : [];
            const hasSNB = bookings.some(b => Number(b.package_type) === 2);
            const hasSDT = bookings.some(b => Number(b.package_type) === 1);

            const match =
                (column === 'snb' && hasSNB && !hasSDT) ||
                (column === 'sdt' && hasSDT && !hasSNB) ||
                (column === 'snb_sdt' && hasSNB && hasSDT);

            if (match) {
                modalConversionRows.push({
                    id: modalConversionRows.length + 1,
                    patient_name: patient.patient_name,
                    patient_id: patient.patient_unique_id,
                    mobile_no: patient.patient_contact_no,
                    package_details: bookings
                        .map(b => {
                            const type =
                                b.package_type == 1 ? 'SDT' :
                                    b.package_type == 2 ? 'SNB' : 'Unknown';
                            return `${type} (Booking Date: ${b.tppm_date})`;
                        })
                        .join(', ')
                });
            }
        });

        setTableData(modalConversionRows);
        setIsModalLoading(false);
    };


    return (
        <>
            <div className="mainWrapper bg-slate-50 text-slate-800 pb-5 mb-5">
                {error && (
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                )}
                <div className="d-flex justify-content-end gx-3 mb-4">
                    <button
                        onClick={handleExportToExcel}
                        className="btn btn-light rounded-2xl border border-slate-300 shadow-sm hover:shadow focus-ring"

                    >
                        Export to Excel
                    </button>
                    <button
                        onClick={handlePrint}
                        className="btn btn-light rounded-2xl border border-slate-300 shadow-sm hover:shadow focus-ring"
                        aria-label="Print Report"
                    >
                        Print
                    </button>

                </div>
                <div className="mx-auto new_div">
                    <header className="d-flex justify-content-between align-items-start gap-4 mb-4 mb-md-5 print:d-none">
                        <div>
                            <p className="text-sm text-slate-500 mt-1">
                                Center: <span className="fw-semibold text-slate-700">{hospitalName}</span> &bull; Date: <span
                                    className="fw-semibold text-slate-700">{dateRange}</span>
                            </p>
                        </div>


                    </header>



                    {/* Lead Source Section  */}
                    <section className="mt-4">
                        <h3 className="h6 fw-semibold text-slate-700 mb-3 d-flex align-items-center">
                            Lead Details
                            {loadingStates.leads && <LoadingSpinner />}
                        </h3>
                        <div className="card shadow-sm overflow-hidden">
                            <div className="card-body p-3 p-md-4">
                                <div className="table-responsive">
                                    <table className="table mb-0">
                                        <thead>
                                            <tr>
                                                <th className="w-50">Source</th>
                                                <th className='text-center'>Total</th>
                                                <th className='text-center'>Converted to OPD</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leadData.details.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.source}</td>
                                                    <td className="text-center"
                                                        style={item.total != 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                            textDecoration: "underline",
                                                        } : {}}
                                                        onClick={item.total != 0 ? () => {
                                                            fetchDetails(apiPayload, 'lead', 'total', item.source_id)
                                                        } : undefined}
                                                    >{item.total}</td>
                                                    <td className="text-center"
                                                        style={item.converted != 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                            textDecoration: "underline",
                                                        } : {}}
                                                        onClick={item.converted != 0 ? () => {
                                                            fetchDetails(apiPayload, 'lead', 'converted', item.source_id)
                                                        } : undefined}
                                                    >{item.converted}</td>
                                                </tr>
                                            ))}
                                            <tr className="bg-slate-100 fw-semibold">
                                                <td>Total</td>
                                                <td className="text-center">{leadData.total.total}</td>
                                                <td className="text-center">{leadData.total.converted}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Patients Details Section */}
                    <section className="mt-5">
                        <h3 className="h6 fw-semibold text-slate-700 mb-3 d-flex align-items-center">
                            Patients Details
                            {loadingStates.leads && <LoadingSpinner />}
                        </h3>
                        <div className="card shadow-sm overflow-hidden">
                            <div className="card-body p-3 p-md-4">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="stat-card">
                                            <div className="text-xs text-slate-500 text-uppercase">Transferred FROM Other Center</div>
                                            <div className="h4 fw-semibold mt-1"
                                                style={patientTransferData.transfer_from_here > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}
                                                }
                                                onClick={patientTransferData.transfer_from_here > 0 ? () => { fetchDetails(apiPayload, 'patient', 'from_other_center') } : undefined}   >
                                                {patientTransferData.transfer_from_here}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="stat-card">
                                            <div className="text-xs text-slate-500 text-uppercase">Transferred TO Other Center</div>

                                            <div className="h4 fw-semibold mt-1"
                                                style={patientTransferData.transfer_to_here > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}
                                                }
                                                onClick={patientTransferData.transfer_to_here > 0 ? () => { fetchDetails(apiPayload, 'patient', 'to_other_center') } : undefined}   >
                                                {patientTransferData.transfer_to_here}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* OPD Details Section  */}
                    <section className="mt-5">
                        <h3 className="h6 fw-semibold text-slate-700 mb-3 d-flex align-items-center">
                            OPD Details
                            {loadingStates.opd && <LoadingSpinner />}
                        </h3>
                        <div className="card shadow-sm overflow-hidden">
                            <div className="card-body p-3 p-md-4">
                                <div className="table-responsive">
                                    <table className="table mb-0">
                                        <thead>
                                            <tr>
                                                <th className="w-50">Details</th>
                                                {opdData.map(doctor => (
                                                    <th key={doctor.id} className='text-center'>Dr. {doctor.doctor_name}</th>
                                                ))}
                                                <th className='text-center fw-bold'>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Pending OPD</td>
                                                {opdData.map(doctor => (
                                                    <td key={doctor.id} className="text-center"
                                                        style={doctor.scheduled_opd > 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                            textDecoration: "underline",
                                                        } : {}}
                                                        onClick={
                                                            doctor.scheduled_opd > 0 ? () => {
                                                                fetchDetails(apiPayload, 'opd', doctor.id, 'pending_opd')
                                                            } : undefined
                                                        }
                                                    >{doctor.scheduled_opd || 0}
                                                    </td>
                                                ))}
                                                <td className="text-center fw-bold">{opdTotal.scheduled_opd}</td>
                                            </tr>
                                            <tr>
                                                <td>Completed OPD</td>

                                                {opdData.map(doctor => (
                                                    <td key={doctor.id} className="text-center"
                                                        style={doctor.opd > 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                            textDecoration: "underline",
                                                        } : {}}
                                                        onClick={
                                                            doctor.opd > 0 ? () => {
                                                                fetchDetails(apiPayload, 'opd', doctor.id, 'completed_opd')
                                                            } : undefined
                                                        }
                                                    >{doctor.opd || 0}
                                                    </td>
                                                ))}
                                                <td className="text-center fw-bold">{opdTotal.opd}</td>
                                            </tr>

                                            <tr>
                                                <td>Unique OPD Patients</td>

                                                {opdData.map(doctor => (
                                                    <td key={doctor.id} className="text-center"
                                                        style={doctor.unique_opd_patients > 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                            textDecoration: "underline",
                                                        } : {}}
                                                        onClick={
                                                            doctor.unique_opd_patients > 0 ? () => {
                                                                fetchDetails(apiPayload, 'opd', doctor.id, 'unique_opd_patient')
                                                            } : undefined
                                                        }
                                                    >{doctor.unique_opd_patients || 0}
                                                    </td>
                                                ))}
                                                <td className="text-center fw-bold">{opdTotal.unique_opd_patients}</td>
                                            </tr>
                                            <tr>
                                                <td>New OPD Patients</td>

                                                {opdData.map(doctor => (
                                                    <td key={doctor.id} className="text-center"
                                                        style={doctor.new_opd > 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                            textDecoration: "underline",
                                                        } : {}}
                                                        onClick={
                                                            doctor.new_opd > 0 ? () => {
                                                                fetchDetails(apiPayload, 'opd', doctor.id, 'new_opd_patient')
                                                            } : undefined
                                                        }
                                                    >{doctor.new_opd || 0}
                                                    </td>
                                                ))}
                                                <td className="text-center fw-bold">{opdTotal.new_opd}</td>
                                            </tr>
                                            <tr>
                                                <td>Followup OPD Patients</td>

                                                {opdData.map(doctor => (
                                                    <td key={doctor.id} className="text-center"
                                                        style={doctor.old_opd > 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                            textDecoration: "underline",
                                                        } : {}}
                                                        onClick={
                                                            doctor.old_opd > 0 ? () => {
                                                                fetchDetails(apiPayload, 'opd', doctor.id, 'old_opd_patient')
                                                            } : undefined
                                                        }
                                                    >{doctor.old_opd || 0}
                                                    </td>
                                                ))}
                                                <td className="text-center fw-bold">{opdTotal.old_opd}</td>
                                            </tr>
                                            <tr>
                                                <td>Recommended SNB</td>

                                                {opdData.map(doctor => (
                                                    <td key={doctor.id} className="text-center"
                                                        style={doctor.recommendation_snb > 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                            textDecoration: "underline",
                                                        } : {}}
                                                        onClick={
                                                            doctor.recommendation_snb > 0 ? () => {
                                                                fetchDetails(apiPayload, 'opd', doctor.id, 'recommended_snb')
                                                            } : undefined
                                                        }
                                                    >{doctor.recommendation_snb || 0}
                                                    </td>
                                                ))}
                                                <td className="text-center fw-bold">{opdTotal.recommendation_snb}</td>
                                            </tr>
                                            <tr>
                                                <td>Convert to SNB</td>

                                                {opdData.map(doctor => (
                                                    <td key={doctor.id} className="text-center"
                                                        style={doctor.convert_to_snb > 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                            textDecoration: "underline",
                                                        } : {}}
                                                        onClick={
                                                            doctor.convert_to_snb > 0 ? () => {
                                                                fetchDetails(apiPayload, 'opd', doctor.id, 'convert_to_snb')
                                                            } : undefined
                                                        }
                                                    >{doctor.convert_to_snb || 0}
                                                    </td>
                                                ))}

                                                <td className="text-center fw-bold">{opdTotal.convert_to_snb}</td>
                                            </tr>
                                            <tr>
                                                <td>Recommended SDT</td>

                                                {opdData.map(doctor => (
                                                    <td key={doctor.id} className="text-center"
                                                        style={doctor.recommendation_sdt > 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                            textDecoration: "underline",
                                                        } : {}}
                                                        onClick={
                                                            doctor.recommendation_sdt > 0 ? () => {
                                                                fetchDetails(apiPayload, 'opd', doctor.id, 'recommended_sdt')
                                                            } : undefined
                                                        }
                                                    >{doctor.recommendation_sdt || 0}
                                                    </td>
                                                ))}
                                                <td className="text-center fw-bold">{opdTotal.recommendation_sdt}</td>
                                            </tr>
                                            <tr>
                                                <td>Convert To SDT</td>

                                                {opdData.map(doctor => (
                                                    <td key={doctor.id} className="text-center"
                                                        style={doctor.convert_to_sdt > 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                            textDecoration: "underline",
                                                        } : {}}
                                                        onClick={
                                                            doctor.convert_to_sdt > 0 ? () => {
                                                                fetchDetails(apiPayload, 'opd', doctor.id, 'convert_to_sdt')
                                                            } : undefined
                                                        }
                                                    >{doctor.convert_to_sdt || 0}
                                                    </td>
                                                ))}
                                                <td className="text-center fw-bold">{opdTotal.convert_to_sdt}</td>
                                            </tr>
                                            <tr>
                                                <td>Recommended SDT+SNB</td>

                                                {opdData.map(doctor => (
                                                    <td key={doctor.id} className="text-center"
                                                        style={doctor.recommended_sdt_snb > 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                            textDecoration: "underline",
                                                        } : {}}
                                                        onClick={
                                                            doctor.recommended_sdt_snb > 0 ? () => {
                                                                fetchDetails(apiPayload, 'opd', doctor.id, 'recommended_snb_sdt')
                                                            } : undefined
                                                        }
                                                    >{doctor.recommended_sdt_snb || 0}
                                                    </td>
                                                ))}

                                                <td className="text-center fw-bold">{opdTotal.recommended_sdt_snb}</td>
                                            </tr>


                                            <tr>
                                                <td>Convert to SNB+SDT</td>

                                                {opdData.map(doctor => (
                                                    <td key={doctor.id} className="text-center"
                                                        style={doctor.convert_to_snb_sdt > 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                            textDecoration: "underline",
                                                        } : {}}
                                                        onClick={
                                                            doctor.convert_to_snb_sdt > 0 ? () => {
                                                                fetchDetails(apiPayload, 'opd', doctor.id, 'convert_to_snb_sdt')
                                                            } : undefined
                                                        }
                                                    >{doctor.convert_to_snb_sdt || 0}
                                                    </td>
                                                ))}
                                                <td className="text-center fw-bold">{opdTotal.convert_to_snb_sdt}</td>
                                            </tr>

                                            <tr>
                                                <td>Recommended CT-angio</td>

                                                {opdData.map(doctor => (
                                                    <td key={doctor.id} className="text-center"
                                                        style={doctor.recommended_ct_angio > 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                            textDecoration: "underline",
                                                        } : {}}
                                                        onClick={
                                                            doctor.recommended_ct_angio > 0 ? () => {
                                                                fetchDetails(apiPayload, 'opd', doctor.id, 'recommended_ct_angio')
                                                            } : undefined
                                                        }
                                                    >{doctor.recommended_ct_angio || 0}
                                                    </td>
                                                ))}
                                                <td className="text-center fw-bold">{opdTotal.recommended_ct_angio}</td>
                                            </tr>
                                            <tr>
                                                <td>Recommended to Medical Management</td>

                                                {opdData.map(doctor => (
                                                    <td key={doctor.id} className="text-center"
                                                        style={doctor.recommended_medical_management > 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                            textDecoration: "underline",
                                                        } : {}}
                                                        onClick={
                                                            doctor.recommended_medical_management > 0 ? () => {
                                                                fetchDetails(apiPayload, 'opd', doctor.id, 'recommended_medical_management')
                                                            } : undefined
                                                        }
                                                    >{doctor.recommended_medical_management || 0}
                                                    </td>
                                                ))}
                                                <td className="text-center fw-bold">{opdTotal.recommended_medical_management}</td>
                                            </tr>
                                            <tr>
                                                <td>Not Viable</td>

                                                {opdData.map(doctor => (
                                                    <td key={doctor.id} className="text-center"
                                                        style={doctor.not_viable > 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                            textDecoration: "underline",
                                                        } : {}}
                                                        onClick={
                                                            doctor.not_viable > 0 ? () => {
                                                                fetchDetails(apiPayload, 'opd', doctor.id, 'not_viable')
                                                            } : undefined
                                                        }
                                                    >{doctor.not_viable || 0}
                                                    </td>
                                                ))}
                                                <td className="text-center fw-bold">{opdTotal.not_viable}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Package Details Section */}
                    <section className="mt-5">
                        <h3 className="h6 fw-semibold text-slate-700 mb-3 d-flex align-items-center">
                            Package Details
                            {loadingStates.package && <LoadingSpinner />}
                        </h3>
                        <div className="card shadow-sm overflow-hidden">
                            <div className="card-body p-3 p-md-4">
                                <div className="table-responsive">
                                    <table className="table mb-0">
                                        <thead>
                                            <tr>
                                                <th>Package</th>
                                                <th className='text-center'>SNB</th>
                                                <th className='text-center'>SDT</th>
                                                <th className='text-center'>SNB+SDT</th>
                                                <th className='text-center'>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Day 1 Running</td>
                                                <td className="text-center" style={packageData?.opening_package?.snb > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'snb', 'opening')} >{packageData?.opening_package?.snb || 0}</td>
                                                <td className="text-center" style={packageData?.opening_package?.sdt > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'sdt', 'opening')}  >{packageData?.opening_package?.sdt || 0}</td>
                                                <td className="text-center" style={packageData?.opening_package?.snb_sdt > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'snb_sdt', 'opening')} >{packageData?.opening_package?.snb_sdt || 0}</td>
                                                <td className="text-center">{(packageData?.opening_package?.snb || 0) + (packageData?.opening_package?.sdt || 0) + (packageData?.opening_package?.snb_sdt || 0)}</td>
                                            </tr>
                                            <tr>
                                                <td>New Booking</td>
                                                <td className="text-center" style={packageData?.added_package?.snb > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'snb', 'added')} >{packageData?.added_package?.snb || 0}</td>
                                                <td className="text-center" style={packageData?.added_package?.sdt > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'sdt', 'added')} >{packageData?.added_package?.sdt || 0}</td>
                                                <td className="text-center" style={packageData?.added_package?.snb_sdt > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'snb_sdt', 'added')} >{packageData?.added_package?.snb_sdt || 0}</td>
                                                <td className="text-center">{(packageData?.added_package?.snb || 0) + (packageData?.added_package?.sdt || 0) + (packageData?.added_package?.snb_sdt || 0)}</td>
                                            </tr>
                                            <tr>
                                                <td>Total Run Package</td>
                                                <td className="text-center" style={packageData?.total_run_package?.snb > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'snb', 'total')} >{packageData?.total_run_package?.snb || 0}</td>
                                                <td className="text-center" style={packageData?.total_run_package?.sdt > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'sdt', 'total')} >{packageData?.total_run_package?.sdt || 0}</td>
                                                <td className="text-center" style={packageData?.total_run_package?.snb_sdt > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'snb_sdt', 'total')} >{packageData?.total_run_package?.snb_sdt || 0}</td>
                                                <td className="text-center">{(packageData?.total_run_package?.snb || 0) + (packageData?.total_run_package?.sdt || 0) + (packageData?.total_run_package?.snb_sdt || 0)}</td>
                                            </tr>
                                            <tr>
                                                <td>Scheduled To Complete</td>
                                                <td className="text-center" style={packageData?.schedule_to_complete_packages?.snb > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'snb', 'scheduled_to_complete')} >{packageData?.schedule_to_complete_packages?.snb || 0}</td>
                                                <td className="text-center" style={packageData?.schedule_to_complete_packages?.sdt > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'sdt', 'scheduled_to_complete')} >{packageData?.schedule_to_complete_packages?.sdt || 0}</td>
                                                <td className="text-center" style={packageData?.schedule_to_complete_packages?.snb_sdt > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'snb_sdt', 'scheduled_to_complete')} >{packageData?.schedule_to_complete_packages?.snb_sdt || 0}</td>
                                                <td className="text-center">{(packageData?.schedule_to_complete_packages?.snb || 0) + (packageData?.schedule_to_complete_packages?.sdt || 0) + (packageData?.schedule_to_complete_packages?.snb_sdt || 0)}</td>
                                            </tr>
                                            <tr>
                                                <td>Completed</td>
                                                <td className="text-center" style={packageData?.completed_packages?.snb > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'snb', 'completed')} >{packageData?.completed_packages?.snb || 0}</td>
                                                <td className="text-center" style={packageData?.completed_packages?.sdt > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'sdt', 'completed')} >{packageData?.completed_packages?.sdt || 0}</td>
                                                <td className="text-center" style={packageData?.completed_packages?.snb_sdt > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'snb_sdt', 'completed')} >{packageData?.completed_packages?.snb_sdt || 0}</td>
                                                <td className="text-center">{(packageData?.completed_packages?.snb || 0) + (packageData?.completed_packages?.sdt || 0) + (packageData?.completed_packages?.snb_sdt || 0)}</td>
                                            </tr>
                                            <tr>
                                                <td>Pending to Complete</td>
                                                <td className="text-center" style={packageData?.pending_to_complete_packages?.snb > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'snb', 'pending_to_complete')} >{packageData?.pending_to_complete_packages?.snb || 0}</td>
                                                <td className="text-center" style={packageData?.pending_to_complete_packages?.sdt > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'sdt', 'pending_to_complete')} >{packageData?.pending_to_complete_packages?.sdt || 0}</td>
                                                <td className="text-center" style={packageData?.pending_to_complete_packages?.snb_sdt > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'snb_sdt', 'pending_to_complete')} >{packageData?.pending_to_complete_packages?.snb_sdt || 0}</td>
                                                <td className="text-center">{(packageData?.pending_to_complete_packages?.snb || 0) + (packageData?.pending_to_complete_packages?.sdt || 0) + (packageData?.pending_to_complete_packages?.snb_sdt || 0)}</td>
                                            </tr>

                                            <tr>
                                                <td>Last Day Run</td>
                                                <td className="text-center" style={packageData?.closing_package?.snb > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'snb', 'closing')} >{packageData?.closing_package?.snb || 0}</td>
                                                <td className="text-center" style={packageData?.closing_package?.sdt > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'sdt', 'closing')} >{packageData?.closing_package?.sdt || 0}</td>
                                                <td className="text-center" style={packageData?.closing_package?.snb_sdt > 0 ? {
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                } : {}} onClick={() => fetchPackageDetails(apiPayload, 'package', 'snb_sdt', 'closing')} >{packageData?.closing_package?.snb_sdt || 0}</td>
                                                <td className="text-center">{(packageData?.closing_package?.snb || 0) + (packageData?.closing_package?.sdt || 0) + (packageData?.closing_package?.snb_sdt || 0)}</td>
                                            </tr>



                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* Treatmnet Conversion Details Section */}
                    <section className="mt-5">
                        <h3 className="h6 fw-semibold text-slate-700 mb-3 d-flex align-items-center">
                            Conversion Details
                            {loadingStates.conversion && <LoadingSpinner />}
                        </h3>
                        <div className="card shadow-sm overflow-hidden">
                            <div className="card-body p-3 p-md-4">
                                <div className="table-responsive">
                                    <table className="table mb-0">
                                        <thead>
                                            <tr>
                                                <th>Details</th>
                                                <th className='text-center'>SNB</th>
                                                <th className='text-center'>SDT</th>
                                                <th className='text-center'>SNB+SDT</th>
                                                <th className='text-center'>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {conversionRows.map((row, idx) => (
                                                <tr key={idx}>
                                                    <td>{row.label}</td>
                                                    <td className="text-center"
                                                        style={row.snb > 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                        } : {}}
                                                        onClick={() => showConversionModal(row.label_id, 'snb')}
                                                    >{row.snb}</td>
                                                    <td className="text-center"
                                                        style={row.sdt > 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                        } : {}}
                                                        onClick={() => showConversionModal(row.label_id, 'sdt')}
                                                    >{row.sdt}</td>
                                                    <td className="text-center"
                                                        style={row.snb_sdt > 0 ? {
                                                            cursor: "pointer",
                                                            color: "blue",
                                                        } : {}}
                                                        onClick={() => showConversionModal(row.label_id, 'snb_sdt')}
                                                    >{row.snb_sdt}</td>
                                                    <td className="text-center">{row.total}</td>
                                                </tr>
                                            ))}
                                            <tr className="bg-slate-100 fw-semibold">
                                                <td>Total</td>
                                                <td className="text-center">{conversionTotals.snb}</td>
                                                <td className="text-center">{conversionTotals.sdt}</td>
                                                <td className="text-center">{conversionTotals.snb_sdt}</td>
                                                <td className="text-center">{conversionTotals.total}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Treatment Details Section */}
                    <section className="mt-5">
                        <h3 className="h6 fw-semibold text-slate-700 mb-3 d-flex align-items-center">
                            Treatment Details
                            {loadingStates.package && <LoadingSpinner />}
                        </h3>
                        <div className="card shadow-sm overflow-hidden">
                            <div className="card-body p-3 p-md-4">
                                <div className="table-responsive">
                                    <table className="table mb-0">
                                        <thead>
                                            <tr>
                                                <th>Total</th>
                                                <th className='text-center'>SNB</th>
                                                <th className='text-center'>SDT</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>No. of Machines</td>
                                                <td className="text-center">{treatmentData?.no_of_machine?.snb || 0}</td>
                                                <td className="text-center">{treatmentData?.no_of_machine?.sdt || 0}</td>
                                            </tr>

                                            <tr>
                                                <td>No. of Sittings (Treatments)</td>
                                                <td className="text-center">{treatmentData?.no_of_treatments?.snb || 0}</td>
                                                <td className="text-center">{treatmentData?.no_of_treatments?.sdt || 0}</td>
                                            </tr>
                                            <tr>
                                                <td>No. of Potential Sittings (Treatments)</td>
                                                <td className="text-center">{treatmentData?.no_of_potential_treatment?.snb || 0}</td>
                                                <td className="text-center">{treatmentData?.no_of_potential_treatment?.sdt || 0}</td>
                                            </tr>
                                            <tr>
                                                <td>CUI</td>
                                                <td className="text-center">{treatmentData?.CUI?.snb || 0}%</td>
                                                <td className="text-center">{treatmentData?.CUI?.sdt || 0}%</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>




                </div>
            </div>

            {showModal && (
                <>
                    <div className="modal-backdrop fade show w-100 h-100"></div>
                    <div
                        className="modal d-block"
                        tabIndex="-1"
                        style={{ position: "fixed", overflowY: "auto" }}
                    >
                        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{modalTitle}</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowModal(false)}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    {isModalLoading ? (
                                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <table className="table table-bordered">
                                                <thead
                                                    style={{
                                                        position: "sticky",
                                                        top: -18,
                                                        backgroundColor: "white",
                                                        zIndex: 1,
                                                    }}
                                                >

                                                    <tr>
                                                        {tableHeader.map((header, i) => (
                                                            <th key={i}>{header}</th>
                                                        ))}

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {tableData.length > 0 ? (
                                                        tableData.map((item, idx) => (
                                                            <tr key={idx}>
                                                                <td>{idx + 1}</td>
                                                                {
                                                                    (() => {
                                                                        if (selectedTable == 'opd') {
                                                                            return tableConfig[selectedTable][selectedRow]?.fields.map((field, i) => (
                                                                                <td key={i}>{item[field] || '-'}</td>
                                                                            ))
                                                                        } else {
                                                                            return tableConfig[selectedTable][selectedColumn]?.fields.map((field, i) => (
                                                                                <td key={i}>{item[field] || '-'}</td>))

                                                                        }

                                                                    })()
                                                                }

                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={tableHeader.length} className="text-center">
                                                                No records found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {showPackageModal && (
                <>
                    {/* Backdrop */}
                    <div className="modal-backdrop fade show w-100 h-100"></div>

                    {/* Modal */}
                    <div
                        className="modal d-block"
                        tabIndex="-1"
                        style={{ position: "fixed", overflowY: "auto", zIndex: 1050 }}
                    >
                        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" style={{ maxWidth: "1400px" }}>
                            <div className="modal-content">
                                {/* Header */}
                                <div className="modal-header">
                                    <h5 className="modal-title">{modalTitle}</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowPackageModal(false)}
                                    ></button>
                                </div>

                                {/* Body */}
                                <div className="modal-body">
                                    {isModalLoading ? (
                                        <div
                                            className="d-flex justify-content-center align-items-center"
                                            style={{ minHeight: "200px" }}
                                        >
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-bordered align-middle">
                                                <thead
                                                    style={{
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: "#fff",
                                                        zIndex: 2,
                                                    }}
                                                >
                                                    <tr>
                                                        <th style={{ width: "50px" }}>#</th>
                                                        <th>Patient Name</th>
                                                        <th>Contact No</th>
                                                        <th>Patient ID</th>
                                                        <th>Package Type</th>
                                                        <th>Total Sessions</th>
                                                        <th>Treatment Done (In Range)</th>
                                                        <th>Booking Date</th>
                                                        <th>Current Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {tableData.length > 0 ? (
                                                        tableData.map((item, idx) => {
                                                            const pkgCount = item.pm_package_details.length;

                                                            // Handle case where no packages exist
                                                            if (pkgCount === 0) {
                                                                return (
                                                                    <tr key={idx}>
                                                                        <td>{idx + 1}</td>
                                                                        <td>{item.patient_name}</td>
                                                                        <td>{item.pm_contact_no}</td>
                                                                        <td>{item.patient_unique_id}</td>
                                                                        <td colSpan={5} className="text-center">
                                                                            No package data
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            }

                                                            // If patient has one or more packages
                                                            return item.pm_package_details.map((pkg, i) => (
                                                                <tr key={`${idx}-${i}`}>
                                                                    {i === 0 && (
                                                                        <>
                                                                            <td
                                                                                rowSpan={pkgCount}
                                                                                className="align-middle text-center"
                                                                            >
                                                                                {idx + 1}
                                                                            </td>
                                                                            <td
                                                                                rowSpan={pkgCount}
                                                                                className="align-middle"
                                                                            >
                                                                                {item.patient_name}
                                                                            </td>
                                                                            <td
                                                                                rowSpan={pkgCount}
                                                                                className="align-middle"
                                                                            >
                                                                                {item.pm_contact_no}
                                                                            </td>
                                                                            <td
                                                                                rowSpan={pkgCount}
                                                                                className="align-middle"
                                                                            >
                                                                                {item.patient_unique_id}
                                                                            </td>
                                                                        </>
                                                                    )}
                                                                    <td>{ pkg.package_type == 2 ? 'SNB' : pkg.package_type == 1 ? 'SDT' : 'Other'  }</td>
                                                                    <td>{pkg.total_sessions}</td>
                                                                    <td>{pkg.completed_sessions}</td>
                                                                    <td>{pkg.tppm_date}</td>
                                                                    <td>{ (pkg.current_status === 0) ? 'Not Started' : (pkg.current_status === 1) ? 'Activated' : (pkg.current_status === 2) ? 'Completed' : (pkg.current_status === 3) ? 'Cancelled' : (pkg.current_status === 4) ? 'Pending in Cancellation' : 'Unknown' }</td>
                                                                </tr>
                                                            ));
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={9} className="text-center">
                                                                No records found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

        </>

    )
}
export default CenterReportMain;





